import { localStorageInstance } from '@/modules/localStorage'

export function httpTokenInterceptor(
  init?: RequestInit | undefined
): RequestInit {
  const data = {
    ...init,
    headers: {
      ...init?.headers,
      Authorization: `Bearer ${localStorageInstance
        .getUser()
        ?.accessToken.trim()}`,
      'X-CompanyID': String(localStorageInstance.getPersona()?.companyId),
      'X-PersonaID': String(localStorageInstance.getPersona()?.personaId),
      'X-PersonaType': String(localStorageInstance.getPersona()?.personaType)
    }
  }
  return data
}
